import Typography from '@mui/material/Typography';
import {Add} from '@vedmarket/ui-kit';
import {COLORS} from 'config/constants';

const ProductSummary = ({product, onOpenPhoto}: SavedProductSummaryProps) => {
  const hasSummary = Boolean(product.description || product.manufacturer || product.product_photo?.url);

  if (!hasSummary) return null;

  return <div className='saved-product-summary'>
    <div className='saved-product-summary__content'>
      {product.description && <Typography variant='body2' sx={{
        color: COLORS.BLACK_DARK,
        fontWeight: 500,
        lineHeight: '21px',
        letterSpacing: 0,
      }}>
        {product.description}
      </Typography>}
      {product.manufacturer && <Typography variant='caption' sx={{
        color: COLORS.LIGHT_TEXT_SECONDARY,
        textTransform: 'uppercase',
        lineHeight: '16px',
        letterSpacing: 0,
      }}>
        {product.manufacturer}
      </Typography>}
    </div>
    {product.product_photo?.url && <div className='saved-product-summary__photo-slot'>
      <button
        type='button'
        className='saved-product-summary__photo-button'
        aria-label={product.product_photo.title || product.name}
        onClick={() => onOpenPhoto(product.product_photo)}
      >
        <img
          alt={product.product_photo.title || product.name}
          className='saved-product-summary__photo'
          src={product.product_photo.url}
        />
        <span className='saved-product-summary__photo-overlay' aria-hidden='true'>
          <Add />
        </span>
      </button>
    </div>}
  </div>;
};

export default ProductSummary;
